import { Injectable } from '@angular/core';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormControl } from '@angular/forms';
import { PATTER_FILE_NUMBER, PATTER_ADDRESS, PATTERT_NUMBER, PATTER_WITH_SLASH, PATTERN_CMND, PARTERT_PHONENUMBER, PARTERT_PHONE_NUMBER, PATTERN_BHXH, PATTERN_DATE_BIRTH, PATTERN_DDMMYYYY, PATTERN_ID, PATTERN_MMYYYY, PATTERN_NO_UNICODE, PATTERN_PASSPORT, PATTERN_SDT, PATTERN_URL, PATTERN_YEAR, PATTERT, PATTERT_CHAR, PATTERT_CHAR_SEARCH, PATTERT_EMAIL, PATTERT_FLOAT, PATTERT_PASSWORD, PATTERT_PASSWORD_NO, PATTERT_SYMBOL, PATTERT_SYMBOL_NO, PATTERT_USERNAME, PATTERT_WITH_DOT, PRTTERN_WEBSITE, FORM_TO_YEAR, PATTERN_PHONE, PATTERN_DATE, PATTERT_NUMBER_WITH_DOT, PATTERN_DATE_BIRTH_ONLY_S, PATTER_WITH_SLASH_P, PATTERN_BHYT, PATTER_NCC_HGI } from 'src/app/constant/constant';

const moment = _rollupMoment || _moment;

@Injectable({
    providedIn: 'root'
})

export class FunctionService {
  /**
   * @author hangdtt.it5
   * Format tiền tệ thành VNĐ
   * @param number
   */
  formatCurrency(number) {
    return new Intl.NumberFormat('vi', { style: 'currency', currency: 'VND' }).format(Number(number));
  }

  /**
   * @author hangdtt.it5
   * Cho phép nhập số từ 0 - 9
   * @param number
   */
  allowPressNumber(event) {
    var k;
    k = event.charCode;
    return (k > 47 && k < 58);
  }
  /**
   * @author hangdtt.it5
   * Cho phép nhập dấu . trong số thập phân
   * @param number
   */
  allowPressDot(event) {
    var k;
    k = event.charCode;
    return k == 46;
  }

  /**
   * @author hangdtt.it5
   * Cho phép nhập dấu / trong ngày tháng
   * @param number
   */
  allowPressDate(event) {
    var k;
    k = event.charCode;
    return k == 47;
  }
  /**
     * @author hangdtt.it5
     * Cho phép nhập dấu : trong ngày tháng
     * @param number
     */
  allowPressTime(event) {
    var k;
    k = event.charCode;
    return k == 58;
  }
  /**
   * @author hangdtt.it5
   * Không cho phép nhập dấu enter
   * @param number
   */
  notKeypressEnter(event) {
    var k;
    k = event.charCode;
    return (k != 13);
  }

  checkPattern(str, pattern) {
    var regex = new RegExp(pattern);
    return regex.test(str);
  }

  closeModal(id) {
    $("#" + id).hide();
    $(".modal-backdrop").hide();
    $("#" + id).attr("custom", "false");
  }

  openModal(id) {
    $(document).ready(function () {
      $("#" + id + "[custom=false]").remove();
      $("#" + id).attr("custom", "false");
      $('#' + id).appendTo("body");
    });
    $("#" + id).attr("custom", "true");
    $("#" + id).removeClass("fade");
    $("#" + id).show();
  }

  notiError(formControl: FormControl, _error1, _strNoti1, _error2, _strNoti2, _error3?, _strNoti3?) {
    if (formControl.hasError(_error1)) return _strNoti1 + '<br>';
    else
      if (_error2 != null) {
        if (formControl.hasError(_error2)) return _strNoti2 + '<br>';
        else
          if (_error3) return _strNoti3 + '<br>';
          else return '';
      } else return '';
  }

  chosenOnlyYearHandler(event: Moment, datepicker: MatDatepicker<Moment>, formControl) {
    if (formControl.value === null) {
      formControl.setValue(moment());
    }
    let value__ = formControl.value;
    value__.year(event.year());
    formControl.setValue(value__);
    datepicker.close();
  }

  chosenMonthHandler(event: Moment, datepicker: MatDatepicker<Moment>, formControl) {
    formControl.setValue(Number(event.month() + 1) + "/" + event.year());
    datepicker.close();
  }

  chosenYearHandler(event: Moment, datepicker: MatDatepicker<Moment>, formControl) {
    formControl.setValue(event.year());
  }

  checkPhanQuyen(actionId) {
    const user = JSON.parse(localStorage.getItem('user'));
    let count = 0;
    user.phanQuyenChucDanh.forEach(element => {
      if (element.ActionId == actionId && element.Authority == true) {
        count = count + 1;
      } else {
        count = count + 0;
      }
    });
    if (count > 0) return true;
    else return false;
  }

  encodeStringToBase64(str: string): string {
    return btoa(unescape(encodeURIComponent(str)));
  }

  convertFileToBase64AndName(file): Promise<{ file: string, originalFilename: string }> {
    return new Promise<{ file: string, originalFilename: string }>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result?.toString().split(',')[1];
            if (base64String) {
                resolve({ file: base64String, originalFilename: file.name });
            } else {
                reject(new Error(`Failed to read file: ${file.name}`));
            }
        };
        reader.onerror = () => {
            reject(new Error(`Failed to read file: ${file.name}`));
        };
        reader.readAsDataURL(file);
    });
  }

  async convertFilesToBase64AndName(files): Promise<{ file: string, originalFilename: string }[]> {
    const convertedFiles = [];
    for (const file of files) {
        const fileData = await this.convertFileToBase64AndName(file);
        convertedFiles.push(fileData);
    }
    return convertedFiles;
  }

  getPatternByName(patternName: string): string | RegExp | null {
    // Xử lý để lấy giá trị thực tế của pattern dựa vào tên pattern
    switch (patternName) {
      case 'PATTERT_SYMBOL_NO':
        return PATTERT_SYMBOL_NO;
      case 'PATTERT_PASSWORD_NO':
        return PATTERT_PASSWORD_NO;
      case 'PATTERT_SYMBOL':
        return PATTERT_SYMBOL;
      case 'PATTERT_CHAR':
        return PATTERT_CHAR;
      case 'PATTERT_NUMBER':
        return PATTERT_NUMBER;
      case 'PATTERT_FLOAT':
        return PATTERT_FLOAT;
      case 'PARTERT_PHONE_NUMBER':
        return PARTERT_PHONE_NUMBER;
      case 'PARTERT_PHONENUMBER':
        return PARTERT_PHONENUMBER;
      case 'PATTERT_WITH_DOT':
        return PATTERT_WITH_DOT;
      case 'PATTERT':
        return PATTERT;
      case 'PATTERT_PASSWORD':
        return PATTERT_PASSWORD;
      case 'PATTERN_NO_UNICODE':
        return PATTERN_NO_UNICODE;
      case 'PATTERT_USERNAME':
        return PATTERT_USERNAME;
      case 'PATTERT_EMAIL':
        return PATTERT_EMAIL;
      case 'PATTERN_YEAR':
        return PATTERN_YEAR;
      case 'PATTERN_URL':
        return PATTERN_URL;
      case 'PATTERN_DATE_BIRTH':
        return PATTERN_DATE_BIRTH;
      case 'PRTTERN_WEBSITE':
        return PRTTERN_WEBSITE;
      case 'PATTERT_CHAR_SEARCH':
        return PATTERT_CHAR_SEARCH;
      case 'PATTERN_BHXH':
        return PATTERN_BHXH;
      case 'PATTERN_BHYT':
        return PATTERN_BHYT;
      case 'PATTERN_CMND':
        return PATTERN_CMND;
      case 'PATTERN_PASSPORT':
        return PATTERN_PASSPORT;
      case 'PATTERN_ID':
        return PATTERN_ID;
      case 'PATTERN_DDMMYYYY':
        return PATTERN_DDMMYYYY;
      case 'PATTERN_SDT':
        return PATTERN_SDT;
      case 'PATTERN_MMYYYY':
        return PATTERN_MMYYYY;
      case 'PATTER_FILE_NUMBER':
        return PATTER_FILE_NUMBER;
      case 'PATTER_ADDRESS':
        return PATTER_ADDRESS;
      case 'PATTER_WITH_SLASH':
        return PATTER_WITH_SLASH;
      case 'FORM_TO_YEAR':
        return FORM_TO_YEAR ;
      case 'PATTERT_NUMBER_WITH_DOT':
        return PATTERT_NUMBER_WITH_DOT ;
      case 'PATTERN_PHONE':
        return PATTERN_PHONE ;
      case 'PATTERN_DATE':
        return PATTERN_DATE ;
      case 'PATTER_WITH_SLASH_P':
        return PATTER_WITH_SLASH_P ;
      case 'PATTERN_DATE_BIRTH_ONLY_S':
        return PATTERN_DATE_BIRTH_ONLY_S ;
      case 'PATTER_NCC_HGI':
        return PATTER_NCC_HGI ;
      default:
        return PATTER_WITH_SLASH;
    }
  }

  setBlankToNull(obj) {
    if (Array.isArray(obj)) {
      // Nếu obj là mảng, áp dụng setBlankToNull cho từng phần tử
      return obj.map(item => this.setBlankToNull(item));
    } else if (typeof obj === 'object' && obj !== null) {
      // Nếu obj là đối tượng, áp dụng setBlankToNull cho từng thuộc tính
      for (const key in obj) {
        if (obj[key] === '' || obj[key] === 'null' || obj[key] === null || obj[key] === undefined) {
          obj[key] = null;
        } else if (typeof obj[key] === 'object') {
          obj[key] = this.setBlankToNull(obj[key]);
        }
      }
    }
    return obj;
  }
}
